<!-- 各種ダウンロード -->
<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <div v-if="isInitError" id="contents1">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-if="isDataFetched" id="contents1">
    <section class="com_sec1">
      <div class="com_inner1 clearfix">
        <!-- パンくずリスト -->
        <BreadcrumbsComponent :title="''" :categoryId="categoryId" />
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div
        v-if="errorMessage"
        class="error-message com_mgb10"
        style="white-space: pre-wrap"
      >
        {{ errorMessage }}
      </div>
      <div class="com_inner1 clearfix">
        <!-- 実績データ -->
        <div class="com_i_title1 com_mgt20" style="min-height: 48px">
          <div>
            <img
              :src="getImageUrl('icon-c-data1.png')"
              alt=""
              class="icon-c-data1"
            />
            <h2>実績データ</h2>
          </div>
        </div>
        <div class="com_topic_list4">
          <div class="head1">
            <div>更新日付</div>
            <div>名称／内容</div>
            <div>ダウンロード</div>
          </div>
          <div
            v-for="(rpt, index) in getDisplayList(
              ReportDownloadConstants.RPT_KBN_ACHIEVEMENT_DATA
            )"
            :key="index"
          >
            <div class="meta1">
              <span class="date1 roboto">{{ rpt.updDate }}</span>
            </div>
            <div class="body1">
              <div>
                <p class="t1">
                  <router-link :to="rpt.categoryUrl" class="com_link1">
                    {{ rpt.rptName }}
                  </router-link>
                </p>
                <p class="t2">{{ rpt.rptGaiyo }}</p>
              </div>
            </div>
            <div class="buttons1">
              <router-link :to="rpt.categoryUrl" class="com_dl_button2"
                ><span>ダウンロード</span></router-link
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import BreadcrumbsComponent from "../layout/BreadcrumbsComponent.vue";
import { outputDebugLogs, scrollToTop, commonHandleAxiosError } from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import BackToTop from "../controls/BackToTop.vue";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import { useProcessingStore } from "../../store/useProcessingStore";
import "vue-loading-overlay/dist/css/index.css";

interface reportItem {
  kbn: string; // 帳票区分
  updDate: string; // 更新日付
  categoryUrl: string; // カテゴリURL
  rptName: string; // 帳票名
  rptGaiyo: string; // 帳票概要
}

class ReportDownloadConstants {
  // 帳票区分
  static readonly RPT_KBN_ACHIEVEMENT_DATA = "0"; // 実績データ
}

export default defineComponent({
  name: "ReportDownloadComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BreadcrumbsComponent,
    BackToTop,
  },
  setup() {
    const { getCategoryIdByName } = useUserParmitionStore();
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const agCode = ref(""); // AGコード
    const userId = ref(""); // ユーザーID
    const daihyoCode = ref(""); // 代表コード
    const pseudoAgCode = ref(""); // 疑似ログインAGコード
    const pseudoUserId = ref(""); // 疑似ログインユーザーID
    const pseudoDaihyoCode = ref(""); // 疑似ログイン代表コード
    const serchAgCode = ref(""); // 検索用AGコード
    const serchUserId = ref(""); // 検索用ユーザーID
    const serchDaihyoCode = ref(""); // 検索用代表コード
    const categoryId = ref(""); // カテゴリID
    const reportList = ref<reportItem[]>([]); // レポートデータリスト

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, false);
    };

    /**
     * 初期処理
     */
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 初期処理時はTrue
        isInitError.value = true;

        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          daihyoCode.value = parsedUserInfo.daihyoCode;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          pseudoDaihyoCode.value = parsedUserInfo.pseudoDaihyoCode;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;

          if (pseudoUserId.value == "") {
            // 疑似ログインIDが空の場合は、疑似ログインしていないとみなす
            serchUserId.value = userId.value;
            serchAgCode.value = agCode.value;
            serchDaihyoCode.value = daihyoCode.value;
          } else {
            outputDebugLogs("疑似ログイン状態");
            serchUserId.value = pseudoUserId.value;
            serchAgCode.value = pseudoAgCode.value;
            serchDaihyoCode.value = pseudoDaihyoCode.value;
          }

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
          outputDebugLogs("カウネット管理者：" + isKaunetAdmin.value);
        }

        // カテゴリID取得
        categoryId.value = getCategoryIdByName(
          AppConstants.CATEGORY_NAME_DOWNLOAD
        ) as string;

        // 初期表示データ取得API
        const response = await apiAuthClient.post(
          "/api/ReportDownload/getInitialData",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: serchUserId.value,
            agCode: serchAgCode.value,
            daihyoCode: serchDaihyoCode.value,
            kanriAgCode: pseudoAgCode.value,
            kanriUserId: pseudoUserId.value,
          }
        );

        // レスポンスからデータを取得
        const data = response.data;
        reportList.value = data.reportList;

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /**
     * 画像URL取得
     * @param imgFileName 画像ファイル名
     */
    const getImageUrl = (imgFileName: string) => {
      try {
        return require(`@/assets/common/img/${imgFileName}`);
      } catch (e) {
        console.error(`Failed to load image: ${imgFileName}`, e);
        return "";
      }
    };

    /**
     * 帳票区分に応じた表示リストを取得
     * @param kbn 帳票区分
     */
    const getDisplayList = (kbn: string) => {
      return reportList.value.filter((item) => item.kbn === kbn);
    };

    return {
      AppConstants,
      ReportDownloadConstants,
      getImageUrl,
      scrollToTop,
      isInitError,
      isDataFetched,
      isKaunetAdmin,
      errorMessage,
      categoryId,
      reportList,
      getDisplayList,
    };
  },
});
</script>
